import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

// We must know the full size of the handle in order to scale/translate it into
// position next to the text.
const handleSize = 102;
const courseloadSwirl = (
    <g>
        <rect
            x="-0.875"
            y="-1"
            fill="#445561"
            width={handleSize}
            height={handleSize}
        />
        <path
            fill="#7EAFDE"
            d="M65.934,41.908c-0.038-0.13-0.076-0.255-0.121-0.375c-0.195-0.57-0.45-1.12-0.752-1.637
            c-0.632-1.084-1.463-2.011-2.473-2.765c-0.445-0.336-1.081-0.243-1.415,0.205c-0.32,0.43-0.229,1.089,0.205,1.417
            c1.258,0.942,2.162,2.232,2.612,3.738c0.667,2.217,0.241,4.64-1.141,6.486c-1.166,1.56-2.874,2.574-4.806,2.856
            c-1.934,0.275-3.857-0.213-5.418-1.38c-0.448-0.335-1.084-0.243-1.419,0.202c-0.321,0.436-0.224,1.097,0.204,1.42
            c1.012,0.755,2.137,1.288,3.349,1.588c0.582,0.144,1.182,0.229,1.786,0.263c0.598,0.026,1.198-0.003,1.786-0.088
            c0.586-0.086,1.169-0.224,1.738-0.422c0.565-0.197,1.115-0.452,1.642-0.755c1.078-0.629,2.005-1.46,2.763-2.468
            c0.752-1.012,1.287-2.139,1.585-3.35c0.144-0.583,0.233-1.185,0.26-1.786c0.028-0.596,0.002-1.197-0.083-1.787
            C66.17,42.809,66.07,42.349,65.934,41.908"
        />
        <path
            fill="#7EAFDE"
            d="M73.9,39.508c-0.074-0.239-0.15-0.479-0.231-0.715c-0.373-1.075-0.854-2.119-1.426-3.099
            c-0.581-0.998-1.268-1.941-2.036-2.808c-0.793-0.892-1.679-1.703-2.635-2.417c-0.214-0.161-0.483-0.231-0.75-0.194
            c-0.27,0.042-0.505,0.183-0.667,0.397c-0.321,0.43-0.226,1.096,0.205,1.418c2.691,2.013,4.625,4.78,5.592,7.997
            c1.425,4.739,0.513,9.925-2.44,13.873c-2.497,3.337-6.147,5.501-10.284,6.1c-4.132,0.596-8.246-0.452-11.584-2.946
            c-0.22-0.162-0.484-0.23-0.752-0.192c-0.267,0.038-0.504,0.181-0.667,0.397c-0.322,0.432-0.227,1.093,0.204,1.417
            c0.96,0.717,1.99,1.336,3.066,1.841c1.041,0.493,2.143,0.884,3.268,1.163c1.099,0.271,2.235,0.438,3.375,0.494
            c1.129,0.051,2.268-0.004,3.382-0.164c1.117-0.162,2.227-0.428,3.29-0.8c1.072-0.374,2.113-0.853,3.1-1.427
            c0.997-0.583,1.943-1.27,2.811-2.036c0.886-0.788,1.697-1.676,2.416-2.635c0.716-0.957,1.334-1.985,1.841-3.062
            c0.494-1.045,0.884-2.147,1.163-3.269c0.271-1.1,0.438-2.239,0.49-3.377c0.055-1.126,0.003-2.262-0.159-3.379
            C74.344,41.215,74.153,40.349,73.9,39.508"
        />
        <path
            fill="#7EAFDE"
            d="M89.827,34.699c-0.141-0.463-0.29-0.929-0.448-1.382c-0.727-2.089-1.657-4.113-2.77-6.021
            c-1.134-1.942-2.467-3.78-3.958-5.456c-1.528-1.718-3.25-3.301-5.116-4.696c-0.445-0.333-1.082-0.242-1.416,0.204
            c-0.322,0.432-0.228,1.099,0.205,1.417c5.555,4.156,9.548,9.866,11.549,16.511c2.939,9.788,1.061,20.496-5.043,28.648
            c-5.151,6.888-12.692,11.36-21.231,12.592s-17.033-0.93-23.921-6.083c-0.217-0.162-0.484-0.229-0.752-0.19
            c-0.268,0.041-0.504,0.177-0.667,0.397c-0.322,0.424-0.227,1.091,0.204,1.415c1.865,1.393,3.865,2.599,5.949,3.579
            c2.032,0.96,4.167,1.715,6.351,2.256c2.143,0.529,4.351,0.854,6.56,0.958c2.189,0.104,4.402,0,6.571-0.313
            c2.179-0.313,4.327-0.838,6.391-1.555c2.09-0.727,4.114-1.659,6.02-2.772c1.943-1.133,3.776-2.462,5.456-3.956
            c1.722-1.53,3.304-3.253,4.698-5.117c1.394-1.863,2.597-3.865,3.578-5.947c0.959-2.033,1.718-4.17,2.258-6.351
            c0.525-2.141,0.848-4.35,0.956-6.559c0.104-2.19-0.003-4.399-0.314-6.572C90.689,38.02,90.321,36.334,89.827,34.699"
        />
        <path
            fill="#FFFFFF"
            d="M43.331,45.773c0.131,0.002,0.264,0.006,0.396,0.011c0.6,0.029,1.201,0.117,1.785,0.262
            c1.214,0.299,2.34,0.834,3.346,1.589c0.448,0.334,0.54,0.97,0.208,1.418c-0.327,0.428-0.986,0.523-1.418,0.204
            c-1.26-0.942-2.756-1.445-4.327-1.453c-2.316-0.012-4.521,1.081-5.9,2.925c-1.167,1.56-1.659,3.484-1.379,5.418
            c0.277,1.934,1.29,3.642,2.851,4.809c0.447,0.336,0.538,0.972,0.207,1.417c-0.328,0.434-0.989,0.526-1.419,0.204
            c-1.01-0.756-1.842-1.683-2.469-2.763c-0.302-0.517-0.553-1.068-0.754-1.638c-0.197-0.567-0.336-1.15-0.423-1.739
            c-0.084-0.585-0.113-1.188-0.085-1.788c0.029-0.595,0.115-1.197,0.262-1.783c0.298-1.216,0.833-2.342,1.585-3.349
            c0.758-1.01,1.687-1.84,2.763-2.471c0.522-0.301,1.072-0.556,1.643-0.75c0.56-0.199,1.144-0.339,1.738-0.425
            C42.399,45.803,42.868,45.771,43.331,45.773"
        />
        <path
            fill="#FFFFFF"
            d="M43.382,37.455c0.249,0.001,0.501,0.011,0.749,0.02c1.138,0.057,2.278,0.224,3.377,0.493
            c1.123,0.278,2.22,0.667,3.268,1.161c1.082,0.51,2.11,1.13,3.064,1.844c0.217,0.163,0.358,0.4,0.398,0.669
            c0.035,0.267-0.031,0.534-0.193,0.749c-0.323,0.433-0.985,0.528-1.419,0.204c-2.689-2.014-5.889-3.085-9.25-3.105
            c-4.947-0.028-9.667,2.313-12.62,6.259c-2.493,3.334-3.541,7.451-2.946,11.586c0.598,4.134,2.763,7.787,6.099,10.283
            c0.218,0.162,0.358,0.397,0.397,0.667c0.037,0.267-0.03,0.533-0.191,0.75c-0.325,0.431-0.989,0.526-1.42,0.205
            c-0.957-0.717-1.844-1.532-2.632-2.418c-0.766-0.863-1.453-1.81-2.036-2.81c-0.572-0.977-1.049-2.021-1.426-3.099
            c-0.373-1.066-0.642-2.173-0.802-3.289c-0.161-1.117-0.214-2.255-0.161-3.382c0.055-1.136,0.219-2.27,0.493-3.378
            c0.28-1.12,0.668-2.221,1.161-3.269c0.508-1.072,1.127-2.103,1.845-3.062c0.716-0.958,1.528-1.844,2.418-2.632
            c0.863-0.767,1.81-1.452,2.807-2.036c0.98-0.575,2.023-1.053,3.101-1.427c1.061-0.371,2.171-0.639,3.286-0.799
            C41.617,37.514,42.505,37.453,43.382,37.455"
        />
        <path
            fill="#FFFFFF"
            d="M43.498,20.819c0.484,0.005,0.973,0.018,1.452,0.037c2.205,0.107,4.414,0.429,6.557,0.958
            c2.184,0.542,4.322,1.302,6.352,2.258c2.084,0.979,4.085,2.184,5.951,3.578c0.446,0.339,0.536,0.974,0.203,1.422
            c-0.322,0.429-0.989,0.525-1.417,0.201c-5.558-4.155-12.164-6.376-19.102-6.417C33.275,22.8,23.535,27.632,17.438,35.782
            c-5.156,6.889-7.316,15.385-6.083,23.922c1.229,8.541,5.699,16.081,12.589,21.235c0.217,0.162,0.358,0.399,0.395,0.666
            c0.038,0.266-0.028,0.534-0.192,0.754c-0.32,0.428-0.981,0.526-1.415,0.201c-1.863-1.39-3.584-2.973-5.116-4.695
            c-1.491-1.681-2.822-3.514-3.959-5.457c-1.111-1.903-2.043-3.93-2.769-6.021c-0.717-2.071-1.243-4.22-1.555-6.389
            c-0.312-2.179-0.42-4.393-0.312-6.571c0.106-2.209,0.429-4.417,0.958-6.557c0.537-2.182,1.297-4.318,2.255-6.354
            c0.983-2.085,2.186-4.084,3.582-5.95c1.395-1.861,2.975-3.584,4.696-5.112c1.679-1.496,3.517-2.824,5.454-3.957
            c1.905-1.112,3.933-2.044,6.021-2.771c2.07-0.719,4.22-1.24,6.391-1.554C40.069,20.928,41.791,20.809,43.498,20.819"
        />
    </g>
);

function extractSelection(props, index) {
    const selections = props.highlight.selections;

    const selection = selections.nde;

    if (!selection) {
        return {};
    }

    // copied from highlight.jsx
    const tly = selection.get(1) + 1; // Nudge highlight down a bit
    const bry = selection.get(3) + 3; // Make highlight a bit taller

    const radius = Math.abs(bry - tly) / 2;
    return {
        x: index === 0 ? selection.get(0) : selection.get(2),
        y: tly + radius,
        radius: radius * 2, // I can't grab them at 1x on my phone
    };
}

class EditingHandles extends React.Component {
    static propTypes = {
        convertSVGCoords: PropTypes.func.isRequired,
        highlight: PropTypes.any, // ¯\_(ツ)_/¯
        onMove: PropTypes.func.isRequired,
        setSelection: PropTypes.func.isRequired,
    };

    static getDerivedStateFromProps = props => {
        return {
            start: extractSelection(props, 0),
            end: extractSelection(props, -1),
        };
    };

    onDrag = (handle, { clientX, clientY }) => {
        this.moveTo(handle, { clientX, clientY });
    };

    onMouseDown = () => {
        // I have no idea why, but it is critical that some place on the page
        // is selected in order for onDrag to fire. If
        // window.getSelection().type in Chrome is Caret then onDrag just won't
        // fire.

        this.props.setSelection();
    };

    onTouchMove = (handle, event) => {
        event.preventDefault();
        const {
            nativeEvent: { touches },
        } = event;
        // touches is not iterable can can't be destrucutred
        const { clientX, clientY } = touches[0];
        this.moveTo(handle, { clientX, clientY });
    };

    moveTo = (handle, { clientX, clientY }) => {
        // IDK why, but when you let go of the button it fires one last event
        // at 0, 0 that needs to be ignored.
        if (!clientX && !clientY) {
            return;
        }
        const newCoords = this.props.convertSVGCoords({ clientX, clientY });

        const tmp = {
            start: this.state.start,
            end: this.state.end,
        };
        tmp[handle] = _.extend({}, this.state[handle], newCoords);
        this.props.onMove(tmp.start, tmp.end);
    };

    render() {
        const start = this.state.start;
        const end = this.state.end;

        if (!(start && end)) {
            return null;
        }
        // const start = this.extractSelection(0);
        // const end = this.extractSelection(-1);

        const startScale = (2 * start.radius) / handleSize;
        const endScale = (2 * end.radius) / handleSize;

        return (
            <g>
                <defs>
                    <mask id="start-mask">
                        <rect
                            x={start.x}
                            y={start.y - start.radius}
                            width={start.radius}
                            height={start.radius * 2}
                            fill="black"
                        />
                    </mask>

                    <clipPath id="left-rect">
                        <rect
                            x={0}
                            y={0}
                            width={start.radius}
                            height={start.radius * 2}
                        />
                    </clipPath>

                    <clipPath id="keep-left">
                        <circle
                            style={{
                                // passing clipPath as a property didn't work, but
                                // using a style is fine.
                                clipPath: 'url(#left-rect)',
                            }}
                            cx={start.radius}
                            cy={start.radius}
                            r={start.radius}
                        />
                    </clipPath>
                    <clipPath id="right-rect">
                        <rect
                            x={end.radius}
                            y={0}
                            width={end.radius}
                            height={end.radius * 2}
                        />
                    </clipPath>
                    <clipPath id="keep-right">
                        <circle
                            style={{
                                // passing clipPath as a property didn't work, but
                                // using a style is fine.
                                clipPath: 'url(#right-rect)',
                            }}
                            cx={end.radius}
                            cy={end.radius}
                            r={end.radius}
                        />
                    </clipPath>
                </defs>

                <g
                    onMouseDown={this.onMouseDown}
                    onTouchStart={this.onMouseDown}
                    onDrag={this.onDrag.bind(null, 'start')}
                    onTouchMove={this.onTouchMove.bind(null, 'start')}
                    onDragEnd={this.onDragEnd}
                    onTouchEnd={this.onDragEnd}
                    key="start-handle"
                    transform={`translate(${start.x - start.radius}, ${start.y -
                        start.radius})`}
                    style={{
                        // passing clipPath as a property didn't work, but
                        // using a style is fine.
                        clipPath: 'url(#keep-left)',
                    }}
                >
                    <g transform={`scale(${startScale})`}>{courseloadSwirl}</g>
                </g>
                <g
                    onMouseDown={this.onMouseDown}
                    onTouchStart={this.onMouseDown}
                    onDrag={this.onDrag.bind(null, 'end')}
                    onTouchMove={this.onTouchMove.bind(null, 'end')}
                    onDragEnd={this.onDragEnd}
                    onTouchEnd={this.onDragEnd}
                    key="end-handle"
                    transform={`translate(${end.x - end.radius}, ${end.y -
                        end.radius})`}
                    style={{
                        // passing clipPath as a property didn't work, but
                        // using a style is fine.
                        clipPath: 'url(#keep-right)',
                    }}
                >
                    <g transform={`scale(${endScale})`}>{courseloadSwirl}</g>
                </g>
            </g>
        );
    }
}

export default EditingHandles;



// WEBPACK FOOTER //
// ./src/components/text_viewer/editing_handles.jsx